/* tslint:disable */
import {
  SocialAccount,
  GamePlayer,
  PlayerShare,
  Content,
  PlayerPrize,
  PlayerNotification,
  PlayerMeta,
  PlayerSurvey,
  PlayerGameCategory,
  GeoPoint
} from '../index';

declare var Object: any;
export interface PlayerInterface {
  "profileImage"?: string;
  "firstName"?: string;
  "lastName"?: string;
  "location"?: GeoPoint;
  "deviceTokens"?: Array<any>;
  "points"?: number;
  "shareCount"?: number;
  "shareIconCount"?: number;
  "shareButtonCount"?: number;
  "shareEmailCount"?: number;
  "shareOthersCount"?: number;
  "adShareCount"?: number;
  "interest"?: string;
  "isEmailRegistered"?: boolean;
  "clubInvites"?: Array<any>;
  "notifications"?: Array<any>;
  "popUpShareFlags"?: any;
  "cashPrizeValue"?: string;
  "preferences"?: Array<any>;
  "isAutoMatch"?: boolean;
  "isRestartRequest"?: boolean;
  "profileNotification"?: Array<any>;
  "lastReadAt"?: Date;
  "resultLastReadAt"?: Date;
  "surveyCount"?: number;
  "gameCount"?: number;
  "rank"?: number;
  "isPrivate"?: boolean;
  "isFirstLogin"?: boolean;
  "positiveAwardCount"?: number;
  "realm"?: string;
  "username"?: string;
  "email": string;
  "emailVerified"?: boolean;
  "id"?: any;
  "password"?: string;
  socialAccounts?: SocialAccount[];
  games?: GamePlayer[];
  accessTokens?: any[];
  shares?: PlayerShare[];
  contents?: Content[];
  playerPrize?: PlayerPrize[];
  playerNotifications?: PlayerNotification[];
  playerMetas?: PlayerMeta[];
  playerSurveys?: PlayerSurvey[];
  playerGameCategory?: PlayerGameCategory[];
}

export class Player implements PlayerInterface {
  "profileImage": string;
  "firstName": string;
  "lastName": string;
  "location": GeoPoint;
  "deviceTokens": Array<any>;
  "points": number;
  "shareCount": number;
  "shareIconCount": number;
  "shareButtonCount": number;
  "shareEmailCount": number;
  "shareOthersCount": number;
  "adShareCount": number;
  "interest": string;
  "isEmailRegistered": boolean;
  "clubInvites": Array<any>;
  "notifications": Array<any>;
  "popUpShareFlags": any;
  "cashPrizeValue": string;
  "preferences": Array<any>;
  "isAutoMatch": boolean;
  "isRestartRequest": boolean;
  "profileNotification": Array<any>;
  "lastReadAt": Date;
  "resultLastReadAt": Date;
  "surveyCount": number;
  "gameCount": number;
  "rank": number;
  "isPrivate": boolean;
  "isFirstLogin": boolean;
  "positiveAwardCount": number;
  "realm": string;
  "username": string;
  "email": string;
  "emailVerified": boolean;
  "id": any;
  "password": string;
  socialAccounts: SocialAccount[];
  games: GamePlayer[];
  accessTokens: any[];
  shares: PlayerShare[];
  contents: Content[];
  playerPrize: PlayerPrize[];
  playerNotifications: PlayerNotification[];
  playerMetas: PlayerMeta[];
  playerSurveys: PlayerSurvey[];
  playerGameCategory: PlayerGameCategory[];
  constructor(data?: PlayerInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Player`.
   */
  public static getModelName() {
    return "Player";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Player for dynamic purposes.
  **/
  public static factory(data: PlayerInterface): Player{
    return new Player(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Player',
      plural: 'players',
      path: 'players',
      idName: 'id',
      properties: {
        "profileImage": {
          name: 'profileImage',
          type: 'string'
        },
        "firstName": {
          name: 'firstName',
          type: 'string'
        },
        "lastName": {
          name: 'lastName',
          type: 'string'
        },
        "location": {
          name: 'location',
          type: 'GeoPoint'
        },
        "deviceTokens": {
          name: 'deviceTokens',
          type: 'Array&lt;any&gt;'
        },
        "points": {
          name: 'points',
          type: 'number',
          default: 0
        },
        "shareCount": {
          name: 'shareCount',
          type: 'number',
          default: 0
        },
        "shareIconCount": {
          name: 'shareIconCount',
          type: 'number',
          default: 0
        },
        "shareButtonCount": {
          name: 'shareButtonCount',
          type: 'number',
          default: 0
        },
        "shareEmailCount": {
          name: 'shareEmailCount',
          type: 'number',
          default: 0
        },
        "shareOthersCount": {
          name: 'shareOthersCount',
          type: 'number',
          default: 0
        },
        "adShareCount": {
          name: 'adShareCount',
          type: 'number',
          default: 0
        },
        "interest": {
          name: 'interest',
          type: 'string'
        },
        "isEmailRegistered": {
          name: 'isEmailRegistered',
          type: 'boolean',
          default: false
        },
        "clubInvites": {
          name: 'clubInvites',
          type: 'Array&lt;any&gt;'
        },
        "notifications": {
          name: 'notifications',
          type: 'Array&lt;any&gt;'
        },
        "popUpShareFlags": {
          name: 'popUpShareFlags',
          type: 'any'
        },
        "cashPrizeValue": {
          name: 'cashPrizeValue',
          type: 'string'
        },
        "preferences": {
          name: 'preferences',
          type: 'Array&lt;any&gt;'
        },
        "isAutoMatch": {
          name: 'isAutoMatch',
          type: 'boolean',
          default: true
        },
        "isRestartRequest": {
          name: 'isRestartRequest',
          type: 'boolean',
          default: false
        },
        "profileNotification": {
          name: 'profileNotification',
          type: 'Array&lt;any&gt;'
        },
        "lastReadAt": {
          name: 'lastReadAt',
          type: 'Date'
        },
        "resultLastReadAt": {
          name: 'resultLastReadAt',
          type: 'Date'
        },
        "surveyCount": {
          name: 'surveyCount',
          type: 'number',
          default: 0
        },
        "gameCount": {
          name: 'gameCount',
          type: 'number',
          default: 0
        },
        "rank": {
          name: 'rank',
          type: 'number',
          default: 0
        },
        "isPrivate": {
          name: 'isPrivate',
          type: 'boolean',
          default: false
        },
        "isFirstLogin": {
          name: 'isFirstLogin',
          type: 'boolean',
          default: true
        },
        "positiveAwardCount": {
          name: 'positiveAwardCount',
          type: 'number',
          default: 0
        },
        "realm": {
          name: 'realm',
          type: 'string'
        },
        "username": {
          name: 'username',
          type: 'string'
        },
        "email": {
          name: 'email',
          type: 'string'
        },
        "emailVerified": {
          name: 'emailVerified',
          type: 'boolean'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
        "password": {
          name: 'password',
          type: 'string'
        },
      },
      relations: {
        socialAccounts: {
          name: 'socialAccounts',
          type: 'SocialAccount[]',
          model: 'SocialAccount',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'playerId'
        },
        games: {
          name: 'games',
          type: 'GamePlayer[]',
          model: 'GamePlayer',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'playerId'
        },
        accessTokens: {
          name: 'accessTokens',
          type: 'any[]',
          model: '',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'userId'
        },
        shares: {
          name: 'shares',
          type: 'PlayerShare[]',
          model: 'PlayerShare',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'playerId'
        },
        contents: {
          name: 'contents',
          type: 'Content[]',
          model: 'Content',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'playerId'
        },
        playerPrize: {
          name: 'playerPrize',
          type: 'PlayerPrize[]',
          model: 'PlayerPrize',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'playerId'
        },
        playerNotifications: {
          name: 'playerNotifications',
          type: 'PlayerNotification[]',
          model: 'PlayerNotification',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'playerId'
        },
        playerMetas: {
          name: 'playerMetas',
          type: 'PlayerMeta[]',
          model: 'PlayerMeta',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'playerId'
        },
        playerSurveys: {
          name: 'playerSurveys',
          type: 'PlayerSurvey[]',
          model: 'PlayerSurvey',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'playerId'
        },
        playerGameCategory: {
          name: 'playerGameCategory',
          type: 'PlayerGameCategory[]',
          model: 'PlayerGameCategory',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'playerId'
        },
      }
    }
  }
}
